/**
 * Users
 */

// React
import React, {FunctionComponent, useContext, useEffect, useState} from 'react';

// Context
import AuthContext from '../../authContext';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  getProductsAction,
  updateProductActions,
  createProductsActions,
  getAllProductsAction,
  getCategoriesAction,
} from './actions';
import {getPartnerCategoriesActions} from '../partners/actions';
import {Store} from '../../redux/reducers';
import {getParcelInventoryItemsAction} from '../parcels/actions';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectAllList,
  makeSelectCategoryLoading,
  makeSelectAllListLoading,
} from './selectors';
import {makeSelectLoading as makeCategoriesLoding} from '../partners/selectors';
import {makeSelectSkusInventoryList} from '../warehouses/selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/list';
import Edit from './components/edit';
import Add from './components/add';
import Inventory from './components/inventory';
import Modal from '../../components/Modal';
import ReportList from '../warehouseInventory/components/reportList';

// UI
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  IconButton,
  InputBase,
  ClickAwayListener,
  FormControl,
  Select,
  MenuItem,
  Box,
  Card,
  CardHeader,
  CardContent,
  LinearProgress,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiArrowRight,
  mdiMagnify,
  mdiKeyOutline,
  mdiFormatListBulleted,
  mdiArchiveOutline,
  mdiPlus,
  mdiAccountMultipleCheck,
  mdiAccountArrowLeft,
  mdiClose,
} from '@mdi/js';

// Helper
import {
  checkMatchMedia,
  removeEmptyValueObject,
  flattenObject,
} from '../../utils/helpers';
import handleError from '../../utils/handleError';
import useQuery from '../../utils/hook/useQuery';

// Type
import {Props, SelectorProps, PayloadUpdate, PayloadCreate} from './interfaces';
import clsx from 'clsx';
import RenderFilter, {Filter} from '../../utils/listDaynamicFilterHookForm';
import {useForm} from 'react-hook-form';
import Can from '../../components/Can';
import CSV from './csv';
import {Link} from 'react-router-dom';
import {makeSelectPartnerCategoriesList} from '../partners/selectors';
import {
  GetInventoryFlowRequestBuilder,
  GetSkuInventoryFlowRequestBuilder,
} from 'client-sdk/src/skus/skus';
import Client from 'client-sdk/src/client';
import reports from '../reports';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& #showFilter .MuiInput-underline::before, & #showFilter .MuiInput-underline::after': {
        borderBottom: '2px solid #DFA01F !important',
      },
    },
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      padding: '10px 0',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cards: {
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      backgroundColor: 'white',
      padding: '14px',
      width: '100%',
      height: '148px',
    },
    iconHeader: {
      // position: 'relative',
      marginTop: '-22px',
      marginRight: '-22px',
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex',
    },
    hover: {
      '&:hover': {
        curser: 'pointer',
      },
    },
    chart: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    progress: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      paddingTop: '8px',
      paddingRight: '24px',
      paddingBottom: '8px',
      paddingLeft: '50px',
      marginLeft: '-35px',
    },

    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    title: {
      fontWeight: 500,
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    link: {
      textDecoration: 'none',
    },
  })
);

// Const
interface ObjectString {
  edit: string;
  detail: string;
  assign: string;
  inventory: string;
}

const translate: ObjectString = {
  edit: 'ویرایش',
  detail: 'جزیيات محصول',
  assign: 'لیست محصول',
  inventory: 'گزارش موجودی محصول',
};

type Inputs = {
  'customerNationalCode.contains': string;
};

const Products: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const {register, handleSubmit, reset} = useForm<Inputs>();
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openSizeReport, setOpenSizeReport] = React.useState(false as boolean);

  const [filters, setFilters] = useState([] as Filter[]);
  const {filtersValues, setFiltersValues} = useQuery({
    page: 0,
    size: 10,
  } as any);
  // const [filtersValues, setFiltersValues] = useState({
  //   page: 0,
  //   size: 10,
  // } as any);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);

  const [openAdd, setopenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);

  const [cardId, setCardId] = useState(0);
  const [cardClicked, setCardClicked] = useState(false as boolean);

  const [openFilterBox, setOpenFilterBox] = React.useState(false);

  const [reportModal, setReportModal] = useState(false as boolean);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [reportLoading, setReportLoading] = useState(false as boolean);
  const [reportList, setReportList] = useState<any>(null);
  const [reportFilters, setReportFilters] = useState<any>({
    page: 0,
    size: 10,
  });

  const [reportId, setReportId] = useState(null as any);
  const [reportCsvData, setReportCsvData] = useState([]);
  const [reportCsvLoading, setReportCsvLoading] = useState(false);
  const [parcelItemsModal, setParcelItemsModal] = useState(false as boolean);
  const [inventoryFilters, setInventoryFilters] = useState({
    page: 0,
    size: 10,
  } as any);

  const token = localStorage.getItem('token') || '';

  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };
  const handleCloseReportModal = () => {
    setReportModal(false);
    setFiltersValues({
      page: 0,
      size: 10,
    });
    setReportList(null);
    setReportCsvData([]);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };
  const handleChangeSizeReportList = (
    event: React.ChangeEvent<{value: unknown}>
  ) => {
    setReportFilters({...reportFilters, page: 0, size: event.target.value});
    fetchReportList(reportId, {...reportFilters, size: event.target.value});
  };

  const onSubmit = (filtervalues: any) => {
    setFiltersValues({
      ...removeEmptyValueObject(filtervalues),
      page: 0,
      size: 10,
    });
    reset({});
    setOpenFilterBox(false);
  };

  useEffect(() => {
    getProducts();
    getAllProductsList();
    getCategories();
    setupFilters();
  }, [filtersValues]);

  useEffect(() => {
    setupFilters();
  }, [props.categoryLoading]);

  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const getProducts = () => {
    const {page, size} = filtersValues;
    const {partnerId} = props.match.params;
    props.productsDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: {equals: partnerId},
      page,
      size,
    });
  };

  const getAllProductsList = () => {
    const {page} = filtersValues;
    const {partnerId} = props.match.params;
    props.allProductsDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: {equals: partnerId},
      page,
      size: 1000,
    });
  };

  const getCategories = () => {
    const {page, size} = filtersValues;
    const {partnerId} = props.match.params;
    props.categoriesDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: {equals: partnerId},
      page,
      size,
    });
  };

  const fetchReportCsv = async () => {
    try {
      setReportCsvLoading(true);
      const parcelId = selectedItem.id;
      const request = new GetInventoryFlowRequestBuilder()
        .id(parcelId)
        .params({size: 10000})
        .build();
      const client = new Client(token);
      const {data} = await client.execute(request);
      setReportCsvData(data.content);
    } catch (e) {
      handleError(e.response);
    } finally {
      setReportCsvLoading(false);
    }
  };

  const fetchReportList = async (id: number, args: Record<string, any>) => {
    try {
      setReportLoading(true);
      const request = new GetSkuInventoryFlowRequestBuilder()
        .id(id)
        .params({
          ...removeEmptyValueObject(flattenObject(reportFilters)),
          ...args,
        })
        .build();

      const client = new Client(token);
      const {data} = await client.execute(request);
      setReportList(data);
    } catch (err) {
      handleError(err.response);
    } finally {
      setReportLoading(false);
    }
  };

  const findSelectedItem = (id: number) => {
    const findSelectSku = props.skusInventoryList.find(
      (el: any) => el.id === id
    )!;
    setSelectedItem(findSelectSku);
  };

  const handleReport = (id: number) => {
    setReportModal(true);
    setId(id);
    fetchReportList(id);
    // props.getParcelsDispatch({'skuId.equals': id, size: 150});
    findSelectedItem(id);
  };

  const handleChangeReportPage = (
    _: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setReportFilters({...reportFilters, page: page - 1});
    fetchReportList(reportId, {...reportFilters, page: page - 1});
  };

  const handleGetParcelInventory = (id: number) => {
    setParcelItemsModal(true);
    setInventoryFilters((prevState: Record<string, any>) => ({
      ...prevState,
      'parcelId.equals': id,
    }));
    getParcelInventoryRequest({'parcelId.equals': id});
  };

  const getParcelInventoryRequest = (arg: Record<string, any>) => {
    props.getParcelInventoryItems({...inventoryFilters, ...arg});
  };

  const setupFilters = () => {
    Can({
      role: authContext.user.role,
      perform: 'orders:filtersByCenterId',
      yes: () => {
        setFilters([
          {
            type: 'input',
            id: 'name.contains',
            label: 'نام کالا',
            icon: mdiArchiveOutline,
          },
          {
            type: 'checkbox',
            id: 'categoryName.contains',
            label: 'دسته بندی',
            icon: mdiFormatListBulleted,
            data: props.categoriesList.map(category => category.name),
            translateType: 'common',
          },
          {
            type: 'input',
            id: 'code.contains',
            label: 'کد کالا',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'sellerId.equals',
            label: 'شناسه فروشنده',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'providerId.equals',
            label: 'شناسه تامین کننده',
            icon: mdiKeyOutline,
          },
          {
            type: 'input',
            id: 'sellerCode.equals',
            label: 'کد فروشنده',
            icon: mdiKeyOutline,
          },
          {
            type: 'input',
            id: 'providerCode.equals',
            label: 'کد تامین کننده',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'id.equals',
            label: 'شناسه کالا',
            icon: mdiKeyOutline,
          },
        ]);
      },
      no: () => {
        setFilters([
          {
            type: 'input',
            id: 'name.contains',
            label: 'نام کالا',
            icon: mdiArchiveOutline,
          },
          {
            type: 'checkbox',
            id: 'productCategory.in',
            label: 'دسته بندی',
            icon: mdiFormatListBulleted,
            data: props.categoriesList.map(category => category.name),
            translateType: 'common',
          },
          {
            type: 'input',
            id: 'code.contains',
            label: 'شناسه کالا',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'id.equals',
            label: 'شناسه کالا',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'sellerId.equals',
            label: 'شناسه فروشنده',
            icon: mdiKeyOutline,
          },
          {
            type: 'number',
            id: 'providerId.equals',
            label: 'شناسه تامین کننده',
            icon: mdiKeyOutline,
          },
          {
            type: 'input',
            id: 'sellerCode.equals',
            label: 'کد فروشنده',
            icon: mdiKeyOutline,
          },
          {
            type: 'input',
            id: 'providerCode.equals',
            label: 'کد تامین کننده',
            icon: mdiKeyOutline,
          },
        ]);
      },
    });
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
        'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleDisableUser = async () => {
    const body = props.productsList.find(item => item.id === id) as any;
    await props.updateProductsDispatch({
      body: {...body, status: 'SUSPENDED'},
      pagination: filtersValues,
      id: props.match.params.partnerId,
    });
    setOpenConfirmDisable(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);
    setId(id);
  };
  const handleOpen = (id: number, type: string) => {
    setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenDialog(false);
    setopenAdd(false);
  };

  const handleOpenConfirmUpdateState = (data: {id: number; body: any}) => {
    setId(data.id);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={5} alignItems="center">
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" component="h2" className={classes.title}>
            {'مدیریت کالاهای شرکت'} {authContext.user.name}
          </Typography>

          {props.match.path !== '/your-products' && (
            <Button
              aria-label="details"
              size="medium"
              onClick={() => window.history.back()}
            >
              <Icon path={mdiArrowRight} size={1} />
              {'بازگشت'}
            </Button>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 10,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'name.contains',
              placeholder: 'نام کالا',
            }}
            filterValues={filtersValues}
          />
        </Grid>
        <Grid
          style={{
            marginTop: '10px',
            marginRight: '-20px',
            marginLeft: '-20px',
            marginBottom: '20px',
          }}
          container
          xs={12}
          justify="flex-end"
        >
          <Can
            role={authContext.user.role}
            perform="parcels:downloadReportCSV"
            yes={() => (
              <>
                <CSV
                  parcelsDispatch={props.allProductsDispatch}
                  data={props.allProductsList}
                  filtersValues={filtersValues}
                  loading={props.allProductsListLoading}
                />
              </>
            )}
          />
          <Can
            role={authContext.user.role}
            perform="/create-product"
            yes={() => (
              <>
                <Link to="/create-product" className={classes.link}>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    startIcon={<Icon path={mdiPlus} size={1} />}
                  >
                    ایجاد محصول جدید
                  </Button>
                </Link>
              </>
            )}
          />
          <Can
            role={authContext.user.role}
            perform="product:grouping-create"
            yes={() => (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  style={{marginRight: '5px'}}
                  onClick={() => props.history.push('/create-grouping-product')}
                  startIcon={<Icon path={mdiPlus} size={1} />}
                  size={
                    checkMatchMedia('(max-width: 1024px)') ? 'small' : 'large'
                  }
                >{`ثبت دسته‌جمعی کالا`}</Button>
              </>
            )}
          />
        </Grid>
        <Grid
          container
          spacing={2}
          md={12}
          style={{
            // justifyContent: 'space-between',
            maxWidth: '120%',
            margin: '32px 1px',
          }}
        >
          {/* <Grid container item lg={12} spacing={2} xs={12}>
            <Grid item md={6} lg={3} xs={6} justify={'center'}>
              <Card className={classes.cards}>
                <CardHeader
                  action={
                    <IconButton
                      aria-label="close"
                      // onClick={id => {
                      //   handleCardClose(1);
                      // }}
                      className={classes.iconHeader}
                    >
                      {cardClicked && cardId === 1 && (
                        <Icon
                          path={mdiClose}
                          size={1}
                          style={{
                            color: '#Ffffff',
                            backgroundColor: '#FFA65A',
                            borderRadius: '3px',
                          }}
                        />
                      )}
                    </IconButton>
                  }
                />
                <CardContent className={classes.cardContent}>
                  <IconButton
                    type="submit"
                    // onClick={id => handleCardClick(1)}
                    aria-label="search"
                    style={{
                      backgroundColor: '#D6EBD3',
                      // height: '30%',
                      // width: '28%',
                      borderRadius: '4px',
                      margin: '-20px 0',
                    }}
                  >
                    <InStock />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{fontWeight: 600, marginTop: '-20px'}}
                    >
                      {props.activeCardCount}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '16px',
                        marginBottom: '-20px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      موجود در انبار
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={6} lg={3} xs={6} justify={'center'}>
              <Card className={classes.cards}>
                <CardHeader
                  action={
                    <IconButton
                      aria-label="close"
                      // onClick={id => {
                      //   handleCardClose(1);
                      // }}
                      className={classes.iconHeader}
                    >
                      {cardClicked && cardId === 1 && (
                        <Icon
                          path={mdiClose}
                          size={1}
                          style={{
                            color: '#Ffffff',
                            backgroundColor: '#FFA65A',
                            borderRadius: '3px',
                          }}
                        />
                      )}
                    </IconButton>
                  }
                />
                <CardContent className={classes.cardContent}>
                  <IconButton
                    type="submit"
                    // onClick={id => handleCardClick(1)}
                    aria-label="search"
                    style={{
                      backgroundColor: '#DFE3FD',
                      // height: '30%',
                      // width: '28%',
                      borderRadius: '4px',
                      margin: '-20px 0',
                    }}
                  >
                    <InProgress />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{fontWeight: 600, marginTop: '-20px'}}
                    >
                      {props.activeCardCount}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '16px',
                        marginBottom: '-20px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      در انتظار پردازش
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={6} lg={3} xs={6} justify={'center'}>
              <Card className={classes.cards}>
                <CardHeader
                  action={
                    <IconButton
                      aria-label="close"
                      // onClick={id => {
                      //   handleCardClose(1);
                      // }}
                      className={classes.iconHeader}
                    >
                      {cardClicked && cardId === 1 && (
                        <Icon
                          path={mdiClose}
                          size={1}
                          style={{
                            color: '#Ffffff',
                            backgroundColor: '#FFA65A',
                            borderRadius: '3px',
                          }}
                        />
                      )}
                    </IconButton>
                  }
                />
                <CardContent className={classes.cardContent}>
                  <IconButton
                    type="submit"
                    // onClick={id => handleCardClick(1)}
                    aria-label="search"
                    style={{
                      backgroundColor: '#FFEDDE',
                      // height: '30%',
                      // width: '28%',
                      borderRadius: '4px',
                      margin: '-20px 0',
                    }}
                  >
                    <Rejected />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{fontWeight: 600, marginTop: '-20px'}}
                    >
                      {props.activeCardCount}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '16px',
                        marginBottom: '-20px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      بازگردانده شده
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={6} lg={3} xs={6}>
              <Card className={classes.cards}>
                <CardHeader
                  action={
                    cardClicked &&
                    cardId === 2 && (
                      <IconButton
                        aria-label="close"
                        // onClick={id => {
                        //   handleCardClose(2);
                        // }}
                        className={classes.iconHeader}
                      >
                        <Icon
                          path={mdiClose}
                          size={1}
                          style={{
                            color: '#Ffffff',
                            backgroundColor: '#FFA65A',
                            borderRadius: '3px',
                          }}
                        />
                      </IconButton>
                    )
                  }
                />
                <CardContent className={classes.cardContent}>
                  <IconButton
                    type="submit"
                    aria-label="search"
                    // onClick={id => handleCardClick(2)}
                    style={{
                      backgroundColor: '#FCD4DA',
                      // height: '60%',
                      // width: '30%',
                      borderRadius: '4px',
                      margin: '-20px 0',
                    }}
                  >
                    <OutStock />
                  </IconButton>
                  <Grid
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginRight: '10px',
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h6"
                      style={{fontWeight: 600, marginTop: '-20px'}}
                    >
                      {props.inactiveCardCount}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: '16px',
                        marginBottom: '-20px',
                        fontWeight: 550,
                        color: '#666666',
                      }}
                    >
                      کسر موجودی
                    </Typography>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid> */}
          {/* <Grid item lg={4} xs={6}>
          <Card className={classes.chart}>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Typography className={classes.typographyCards}>
                فعالترین فروشندگان
              </Typography>
              <Select value={'هفته گذشته'}>
                <MenuItem value={'هفته گذشته'}>هفته گذشته</MenuItem>
              </Select>
            </Grid>
            <div style={{marginTop: '10px'}}>
              <LinearProgress variant="determinate" value={50} />
            </div>
          </Card>
        </Grid> */}
        </Grid>
        <Grid container item spacing={6}>
          <Grid item xs={12}>
            {props.loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              props.productsList && (
                <List
                  handleReport={handleReport}
                  data={props.productsList}
                  handleOpenConfirmDisable={handleOpenConfirmDisable}
                  handleOpen={handleOpen}
                  changeStatus={handleOpenConfirmUpdateState}
                />
              )
            )}
          </Grid>
          <Grid id="showFilter" item xs={12} sm={6}>
            {props.productsList && (
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSize}
                  onClose={handleCloseSelect}
                  className={classes.showCount}
                  onOpen={() => setOpenSize(true)}
                  value={filtersValues.size}
                  onChange={handleChangeSizePage}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid xs={12} sm={6} container item direction="row-reverse">
            {props.productsList && (
              <Pagination
                count={Math.ceil(props.count / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openConfirmDisable}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {` آیا از غیر فعال کردن محصول با نام
          "${props.productsList.find(item => item.id === id)?.name}"
          اطمینان دارید؟`}
        </DialogTitle>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            variant="contained"
            color="primary"
          >
            {'خیر'}
          </Button>
          <Button
            onClick={handleDisableUser}
            variant="outlined"
            color="primary"
          >
            {'بله'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{` 
          ${translate[type]}
        "${props.productsList.find(item => item.id === id)?.name}"
        `}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {'بازگشت'}
          </Button>
        </DialogTitle>
        <DialogContent>
          {type === 'edit' && (
            <Edit
              data={props.productsList.find(item => item.id === id)}
              partnerId={props.match.params.partnerId}
              update={body => {
                props.updateProductsDispatch({
                  body,
                  pagination: filtersValues,
                  id: props.match.params.partnerId,
                });
                handleClose();
              }}
            />
          )}

          {type === 'inventory' && (
            <Inventory
              data={props.productsList.find(product => product.id === id)}
            />
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        fullScreen
        open={openAdd}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>ایجاد محصول جدید</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {'بازگشت'}
          </Button>
        </DialogTitle>
        <DialogContent>
          <Add
            partnerId={props.match.params.partnerId}
            create={body => {
              props.createProductDispatch({
                body,
                pagination: filtersValues,
                id: props.match.params.partnerId,
              });
              handleClose();
            }}
          />
        </DialogContent>
      </Dialog>

      <Modal
        maxWidth="md"
        onClose={handleCloseReportModal}
        open={reportModal}
        title={
          <div style={{textAlign: 'right'}}>
            <span>{`تاریخچه ورود و خروج کالای ${
              props.productsList.find(item => item.id === id)?.name
            }`}</span>
          </div>
        }
        content={
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {reportLoading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <React.Fragment>
                  <Grid item xs={12}>
                    <div style={{textAlign: 'left'}}>
                      <Can
                        role={authContext.user.role}
                        perform="skus:downloadCSV"
                        yes={() => (
                          <CSV
                            loading={reportCsvLoading}
                            handleCreateCSV={fetchReportCsv}
                            data={reportCsvData}
                          />
                        )}
                      />
                    </div>
                    <Box mb={3} />
                  </Grid>
                  <ReportList
                    data={reportList?.content}
                    handleSelect={handleGetParcelInventory}
                  />
                </React.Fragment>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSizeReport}
                  onClose={() => setOpenSizeReport(false)}
                  onOpen={() => setOpenSizeReport(true)}
                  value={reportFilters.size}
                  onChange={handleChangeSizeReportList}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              <Pagination
                className={classes.pagination}
                count={Math.ceil(
                  reportList?.totalElements / reportFilters.size
                )}
                color="secondary"
                page={reportFilters?.page + 1}
                onChange={handleChangeReportPage}
              />
            </Grid>
          </Grid>
        }
      />
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  skusInventoryList: makeSelectSkusInventoryList(),

  productsList: makeSelectList(),
  categoriesList: makeSelectPartnerCategoriesList(),
  allProductsList: makeSelectAllList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  allProductsListLoading: makeSelectAllListLoading(),
  categoryLoading: makeCategoriesLoding(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    productsDispatch: (payload: Record<string, any>) =>
      dispatch(getProductsAction(payload)),
    categoriesDispatch: (payload: Record<string, any>) =>
      dispatch(getPartnerCategoriesActions(payload)),
    allProductsDispatch: (payload: Record<string, any>) =>
      dispatch(getAllProductsAction(payload)),
    updateProductsDispatch: (payload: PayloadUpdate) =>
      dispatch(updateProductActions(payload)),
    createProductDispatch: (payload: PayloadCreate) =>
      dispatch(createProductsActions(payload)),
    getParcelInventoryItems: (payload: any) =>
      dispatch(getParcelInventoryItemsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Products);
